import { toast, ToastOptions, ToastContent, Id } from "react-toastify";

const DEFAULT_POSITION = "top-center";

/**
 * Toast notification wrapper that exposes all react-toastify features.
 * Supports: autoClose, hideProgressBar, pauseOnHover, pauseOnFocusLoss,
 * draggable, closeOnClick, progress, theme, icon, delay, transition, and more.
 */

export interface NotifyOptions extends Omit<ToastOptions, "type"> {
  dismissPrevious?: boolean;
}

function displayToast(message: ToastContent, emoji: string, type: ToastOptions["type"], options?: NotifyOptions): Id {
  const { dismissPrevious = false, ...toastOptions } = options || {};

  if (dismissPrevious) {
    toast.dismiss();
  }

  const content = emoji ? `${emoji} ${message}` : message;
  const position = toastOptions.position || DEFAULT_POSITION;

  return toast(content, {
    ...toastOptions,
    type,
    position,
  });
}

export function error(message: ToastContent, emoji = "", options?: NotifyOptions): Id {
  return displayToast(message, emoji, "error", options);
}

export function success(message: ToastContent, emoji = "", options?: NotifyOptions): Id {
  return displayToast(message, emoji, "success", options);
}

export function warning(message: ToastContent, emoji = "", options?: NotifyOptions): Id {
  return displayToast(message, emoji, "warning", options);
}

export function info(message: ToastContent, emoji = "", options?: NotifyOptions): Id {
  return displayToast(message, emoji, "info", options);
}

// Re-export commonly used react-toastify utilities
export { toast };
